import Fuse from 'fuse.js';
import _ from 'lodash';

const FUSE_OPTIONS = {
  threshold: 0.4,
  location: 0,
  distance: 100,
  minMatchCharLength: 1,
  keys: ['name'],
};

const createAdapter = (collection) => {
  const finder = new Fuse(collection, FUSE_OPTIONS);
  const search = _.memoize(finder.search.bind(finder));
  return (item, term) => {
    const matches = search(term);
    return matches.includes(item);
  };
};

export default createAdapter;
